import { Vector3 } from "three";
import { CharacterAnimationController, CharacterAnimationState } from "../animations/CharacterAnimationController";
import { Character } from "../Character";
import { ICharacterState } from "./ICharacterState";
import { CharacterStates } from "./CharacterStates";
import { AudioController, Sfx } from "../../../AudioController";

export class IdleState implements ICharacterState {
    private nextState: CharacterStates;
    public constructor(
        private readonly character: Character,
        private readonly animationController: CharacterAnimationController,
        private readonly audioController: AudioController
    ) {
        this.nextState = CharacterStates.IDLE;
    }
    
    public enter(): void {
        this.animationController.onClipEnd.add(this.handleClipEnd, this);
        this.animationController.transitToState(CharacterAnimationState.Idle);
    }

    public exit(): void {
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
        this.nextState = CharacterStates.IDLE;
    }

    public process(_dt: number): CharacterStates {
        return this.nextState;
    }

    public onInput(value: Vector3): void {
        this.character.throwTargetPosition = value;
        this.nextState = CharacterStates.THROW;
    }

    public onTakeDamage(amount: number): void {
        this.audioController.playSfx(Sfx.Hit);
        this.character.health.setValue(Math.max(this.character.health.value - amount, 0));
        if ((this.character.isHitReadyDamage && this.character.isHitReadyTime) || !this.character.alive) {
            this.character.throwTargetPosition = null;
            this.nextState = CharacterStates.HIT;
        }
    }

    private handleClipEnd(_state: CharacterAnimationState): void {
        this.animationController.transitToState(CharacterAnimationState.Idle);
    }
}
